import { mapState } from "vuex";
export default {
  methods: {
    filterEquipmentType(item) {
      let res = this.equipmentType?.filter(e => e.id == item)[0];
      let name = res?.name;
      let mainClass = res?.mainClass;
      let subtype = res?.subtype ? `- ${res?.subtype}` : "";
      return `[${mainClass}] ${name} ${subtype}`;
    }
  },
  computed: {
    ...mapState("settings", ["equipmentType"])
  }
};
